import { useContext, useCallback } from 'react'
import { TrueFalseProps, TypeKeysEnum, ModeEnum, StatusEnum } from '../types'
import { MyContext } from '../TQgenerator'
import styled from 'styled-components'

const StyledEditingOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:not(:last-child) {
    margin-bottom: var(--gap-small);
  }

  > *:not(:last-child) {
    margin-right: var(--gap-normal);
  }
`
const StyledOption = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  &:not(:last-child) {
    margin-bottom: var(--gap-small);
  }

  > *:not(:last-child) {
    margin-right: var(--gap-normal);
  }

  span {
    &.answer {
      font-weight: 800;
      color: var(--color-black);
    }
    &.passed {
      font-weight: 400;
      color: var(--color-success);
    }
    &.failed {
      font-weight: 400;
      color: var(--color-danger);
    }
  }

  .option-content {
    display: flex;
    align-items: baseline;
  }
  .option-content-answer {
    min-width: 1em;
    margin-right: 2px;
  }
  .option-content-label {
    line-height: 1.3;
  }
`

const answerOptions = ['O', 'X']
const getInitOptions: (id: string) => TrueFalseProps['options'] = (
  id: string
) => {
  let options: TrueFalseProps['options'] = []
  for (let i = 0; i < answerOptions.length; i++) {
    const key = `${id}-${i}`
    options.push({
      key,
      label: '',
      value: key,
      isChecked: false
    })
  }
  return options
}
export const initTrueFalse: (
  id: string
) => Pick<TrueFalseProps, 'type' | 'boolean' | 'options'> = (id: string) => {
  return {
    type: TypeKeysEnum.是非題,
    boolean: null,
    options: getInitOptions(id)
  }
}

export const TrueFalseComponent = (props: TrueFalseProps) => {
  const context = useContext(MyContext)
  const { components } = context
  const { formItems } = components
  const { Label, Radio, Textarea } = formItems

  const editOptions = useCallback(
    (
      optionKey: string,
      key: 'label' | 'isChecked',
      value?: string | boolean | number
    ) => {
      let { answer, response, options, finalScore, isPass } = props
      if (key === 'isChecked') {
        if (context.status === StatusEnum.editing) {
          answer = optionKey
        }

        if (
          context.status === StatusEnum.waiting_for_response ||
          context.status === StatusEnum.waiting_for_correct
        ) {
          response = optionKey
          if (context.mode === ModeEnum.test) {
            if (response === answer) {
              finalScore = props.score
              isPass = true
            } else {
              finalScore = 0
              isPass = false
            }
          }
        }

        props.updateSection({
          ...props,
          answer,
          response,
          finalScore,
          isPass
        })
      }

      if (key === 'label') {
        const newOptions = options.map((option) => {
          if (key === 'label') {
            if (option.key === optionKey) {
              option.label = value as string
            }
          }
          return option
        })
        props.updateSection({ ...props, options: newOptions })
      }
    },
    [props, context]
  )

  const renderOptionsEditing = () => {
    return props.options.map((option, index) => {
      return (
        <StyledEditingOption key={option.key}>
          <div>{answerOptions[index]}</div>
          <Textarea
            value={option.label}
            onChange={(e: any) =>
              editOptions(option.key, 'label', e.target.value)
            }
            autoSize={{ minRows: 1, maxRows: 4 }}
          />
          {props.mode === ModeEnum.test && (
            <div style={{ width: '200px' }}>
              <Radio
                checked={option.key === props.answer}
                onChange={() => editOptions(option.key, 'isChecked')}
              >
                正確答案
              </Radio>
            </div>
          )}
        </StyledEditingOption>
      )
    })
  }
  const renderOptionsPreviewEditing = () => {
    return props.options.map((option, index) => {
      return (
        <StyledOption key={option.key}>
          <Radio disabled={true} checked={option.key === props.response}>
            <div className="option-content">
              <span className="option-content-answer">
                {answerOptions[index]}
              </span>
              <span
                className="option-content-label"
                dangerouslySetInnerHTML={{
                  __html: option.label.replace(/\n/g, '<br />')
                }}
              />
            </div>
          </Radio>
        </StyledOption>
      )
    })
  }
  const renderOptionsResponse = () => {
    return props.options.map((option, index) => {
      return (
        <StyledOption key={option.key}>
          <Radio
            disabled={props.role !== context.role}
            checked={option.key === props.response}
            onChange={() => editOptions(option.key, 'isChecked')}
          >
            <div className="option-content">
              <span className="option-content-answer">
                {answerOptions[index]}
              </span>
              <span
                className="option-content-label"
                dangerouslySetInnerHTML={{
                  __html: option.label.replace(/\n/g, '<br />')
                }}
              />
            </div>
          </Radio>
        </StyledOption>
      )
    })
  }
  const renderOptionsCorrect = () => {
    return props.options.map((option, index) => {
      let statusClass = ''
      if (props.isPass) {
        if (props.response === option.key) {
          statusClass = 'passed'
        }
      } else if (props.isPass === false) {
        if (props.response === option.key) {
          statusClass = 'failed'
        } else if (props.answer === option.key) {
          statusClass = 'answer'
        }
      }
      return (
        <StyledOption key={option.key}>
          <Radio
            disabled={props.role !== context.role}
            checked={option.key === props.response}
            onChange={() => editOptions(option.key, 'isChecked')}
          >
            <span className={statusClass}>
             <div className="option-content">
              <span className="option-content-answer">
                {answerOptions[index]}
              </span>
              <span
                className="option-content-label"
                dangerouslySetInnerHTML={{
                  __html: option.label.replace(/\n/g, '<br />')
                }}
              />
            </div>
            </span>
          </Radio>
        </StyledOption>
      )
    })
  }
  const renderOptionsFinished = () => {
    return props.options.map((option, index) => {
      let statusClass = ''
      if (props.isPass) {
        if (props.response === option.key) {
          statusClass = 'passed'
        }
      } else if (props.isPass === false) {
        if (props.response === option.key) {
          statusClass = 'failed'
        } else if (props.answer === option.key) {
          statusClass = 'answer'
        }
      }
      return (
        <StyledOption key={option.key}>
          <Radio disabled={true} checked={option.key === props.response}>
            <span className={statusClass}>
              <div className="option-content">
              <span className="option-content-answer">
                {answerOptions[index]}
              </span>
              <span
                className="option-content-label"
                dangerouslySetInnerHTML={{
                  __html: option.label.replace(/\n/g, '<br />')
                }}
              />
            </div>
            </span>
          </Radio>
        </StyledOption>
      )
    })
  }

  const renderOptions = {
    [StatusEnum.editing]: renderOptionsEditing,
    [StatusEnum.preview_editing]: renderOptionsPreviewEditing,
    [StatusEnum.waiting_for_response]: renderOptionsResponse,
    [StatusEnum.waiting_for_correct]: renderOptionsCorrect,
    [StatusEnum.finished]: renderOptionsFinished
  } as const
  return (
    <>
      <Label>選項</Label>
      {context.status &&
        renderOptions[context.status as keyof typeof renderOptions]?.()}
    </>
  )
}
